
export enum AuctionPriceUnit {
  Unknown = 0,
  Hour = 1,
  Day = 2,
  Month = 3,
  SquareMeter = 4,
  Unit = 5
}
